export default __webpack_public_path__ + "static/media/featuresDisplay.e6bd4220.svg";